module.exports = __webpack_public_path__ + "components/flag/static/square/rs-e8718d8aaf531e4c15d09910b6f6e472.svg";